import { render, staticRenderFns } from "./CommentsItemCard.vue?vue&type=template&id=7e97ebac&scoped=true"
import script from "./CommentsItemCard.vue?vue&type=script&lang=js"
export * from "./CommentsItemCard.vue?vue&type=script&lang=js"
import style0 from "./CommentsItemCard.vue?vue&type=style&index=0&id=7e97ebac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e97ebac",
  null
  
)

export default component.exports